import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import EleveListPage from "@/pages/eleves/EleveListPage";
import EleveDetailPage from "@/pages/eleves/EleveDetailPage";
import ModuleListPage from "@/pages/modules/ModuleListPage";
import ModuleDetailPage from "@/pages/modules/ModuleDetailPage";
import PlanningPage from "@/pages/planning/PlanningPage";
import AdminPage from "@/pages/admin/AdminPage";
import ProfilPage from "@/pages/ProfilPage";
import MonSuiviPage from "@/pages/MonSuiviPage";

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <BrowserRouter>
          <AuthProvider>
            <Toaster position="top-right" richColors closeButton />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/eleves" element={<ProtectedRoute requireModule="eleves" requirePermission="eleves" requireAction="view"><EleveListPage /></ProtectedRoute>} />
              <Route path="/eleves/:id" element={<ProtectedRoute requireModule="eleves" requirePermission="eleves" requireAction="view"><EleveDetailPage /></ProtectedRoute>} />
              <Route path="/modules" element={<ProtectedRoute requireModule="modules" requirePermission="modules" requireAction="view"><ModuleListPage /></ProtectedRoute>} />
              <Route path="/modules/:id" element={<ProtectedRoute requireModule="modules" requirePermission="modules" requireAction="view"><ModuleDetailPage /></ProtectedRoute>} />
              <Route path="/planning" element={<ProtectedRoute requireModule="planning" requirePermission="planning" requireAction="view"><PlanningPage /></ProtectedRoute>} />
              <Route path="/mon-suivi" element={<ProtectedRoute eleveOnly><MonSuiviPage /></ProtectedRoute>} />
              <Route path="/profil" element={<ProtectedRoute><ProfilPage /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute adminOnly><AdminPage /></ProtectedRoute>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}

export default App;
